import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ChartProgressionData from '../charts/ChartProgressionData';
import ChartStrategyExecData from '../charts/ChartStrategyExecData';
import CollapseContainer from '../FeedBackSynthesis/CollapseContainer';
import ChartOpinionOnValuation from '../charts/ChartOpinionOnValuation';
import ChartUnderval from '../charts/ChartUnderVal';
import ChartOpinionOnValuationData from '../charts/ChartOpinionOnValuationData';
import ChartUndervalData from '../charts/ChartUnderValData';
import ChartOverValData from '../charts/ChartOverValData';
import ChartMethodologiesData from '../charts/ChartMethodologiesData';
import ChartInfluencesData from '../charts/ChartInfluencesData';
import ChartValuationRetainedData from '../charts/ChartValuationRetainedData';
import ChartStrengthData from '../charts/ChartStrengthData';
import ChartWeaknessData from '../charts/ChartWeaknessData';
import InvestorsImpression from './InvestorsImpression';
import ChartPeerInvestData from '../charts/ChartPeerInvestData';
import DocComponent from './DocComponent';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1280,
    margin: '0 auto'
  },
  chartsContainer: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  subChartsContainer: {
    marginTop: 30
  },
  title: {
    margin: '20px 0',
    fontSize: 22,
    textAlign: 'left'
  },
  subTitle: {
    margin: '20px 0',
    fontSize: 18,
    textAlign: 'left'
  },
  reasons: {
    flex: 0.3,
    marginRight: 15
  },
  docsContainer: {
    marginTop: 30,

    '& h6': {
      margin: '20px 0',
      fontSize: 18,
      width: 500,
      textAlign: 'left'
    }
  }
}));

const fakeDocs = [
  'Model_report_Investor01.pdf',
  'Model_report_Investor02.pdf',
  'Model_report_Investor03.pdf',
  'Model_report_Investor04.pdf',
  'Model_report_Investor05.pdf'
];

const Miscellaneous = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <CollapseContainer>
        <h3 className={classes.title}>Miscellaneous</h3>
        <div className={classes.chartsContainer}>
          <ChartStrengthData />
          <ChartWeaknessData />
        </div>
        <div className={classes.subChartsContainer}>
          <div className={classes.chartsContainer}>
            <InvestorsImpression />
            <ChartPeerInvestData />
          </div>
        </div>
        <div className={classes.docsContainer}>
          <h6>
            Report of Financial Model <br /> (by investor)
          </h6>

          {fakeDocs.map((doc) => (
            <DocComponent docName={doc} />
          ))}
        </div>
      </CollapseContainer>
    </div>
  );
};

export default Miscellaneous;
